import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faPrint, faHandPointUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import PDFModal from "../../../../layout/Popups/PDFModal";
import { btn, btnHoverStyle } from "../../../../layout/Buttons/buttonStyles";

const PrintButton = ({ endpoint, selected, setSelected, projectName }) => {
  const [showSpinner, setShowSpinner] = useState(false);
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1;
  var day = currentDate.getDate();
  var formattedDate = day + "-" + month + "-" + year;

  return (
    <>
      <style>{btnHoverStyle}</style>
      <PDFModal showSpinner={showSpinner} setShowSpinner={setShowSpinner} />
      <div style={{ display: "inline-flex", gap: "6px" }}>
        <button
          className="btn-modern"
          style={{ ...btn.base, ...btn.primary }}
          onClick={() => {
            const data = { tasks: selected };
            setShowSpinner(true);
            downloadHandler(
              endpoint,
              projectName + "_timesheet_" + formattedDate + ".pdf",
              data,
              setShowSpinner
            );
          }}
        >
          <FontAwesomeIcon icon={faPrint} />
        </button>
        <button
          className="btn-modern"
          style={{ ...btn.base, ...btn.secondary }}
          onClick={() => setSelected([])}
        >
          <FontAwesomeIcon icon={faX} />
        </button>
      </div>
    </>
  );
};

const StartSelectionButton = ({ startSelection, setStartSelection }) => {
  return (
    <>
      <style>{btnHoverStyle}</style>
      <button
        className="btn-modern"
        style={{
          ...btn.base,
          ...(startSelection ? btn.primary : btn.secondary),
        }}
        onClick={() => setStartSelection(!startSelection)}
      >
        <FontAwesomeIcon icon={faHandPointUp} />
      </button>
    </>
  );
};

export { StartSelectionButton, PrintButton };
